//#region imports
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  //#region variables
  private characteristicsProgress = new Subject<ProgressBarModel>();
  private detailsProgress = new Subject<ProgressBarModel>();
  private guaranteeProgress = new Subject<ProgressBarModel>();
  private summaryProgress = new Subject<ProgressBarModel>();
  private signatureProgress = new Subject<ProgressBarModel>();

  private mobilecharacteristicsProgress = new Subject<mobileProgressBarModel>();
  private mobiledetailsProgress = new Subject<mobileProgressBarModel>();
  private mobileguaranteeProgress = new Subject<mobileProgressBarModel>();
  private mobilesummaryProgress = new Subject<mobileProgressBarModel>();
  private mobilesignatureProgress = new Subject<mobileProgressBarModel>();
//  private mobileP5XProgress = new Subject<mobileProgressBarModel>();

  //#endregion

  //#region methods
  constructor() { }

  setCharacteristicsProgressStatus(value: ProgressBarModel) {
    this.characteristicsProgress.next(value);
  }

  getCharacteristicsProgressStatus(): Observable<ProgressBarModel> {
    return this.characteristicsProgress.asObservable();
  }

  setDetailsProgressStatus(value: ProgressBarModel) {
    this.detailsProgress.next(value);
  }

  getDetailsProgressStatus(): Observable<ProgressBarModel> {
    return this.detailsProgress.asObservable();
  }

  setGauranteeProgressStatus(value: ProgressBarModel) {
    this.guaranteeProgress.next(value);
  }

  getGauranteeProgressStatus(): Observable<ProgressBarModel> {
    return this.guaranteeProgress.asObservable();
  }

  setSummaryProgressStatus(value: ProgressBarModel) {
    this.summaryProgress.next(value);
  }

  getSummaryProgressStatus(): Observable<ProgressBarModel> {
    return this.summaryProgress.asObservable();
  }

  setSignatureProgressStatus(value: ProgressBarModel) {
    this.signatureProgress.next(value);
  }

  getSignatureProgressStatus(): Observable<ProgressBarModel> {
    return this.signatureProgress.asObservable();
  }
  //#endregion
  //#Mobileregion
  
  setmobileCharacteristicsProgressStatus(value: mobileProgressBarModel) {
    this.mobilecharacteristicsProgress.next(value);
  }

  getmobileCharacteristicsProgressStatus(): Observable<mobileProgressBarModel> {
    return this.mobilecharacteristicsProgress.asObservable();
  }

  setmobileDetailsProgressStatus(value: mobileProgressBarModel) {
    this.mobiledetailsProgress.next(value);
  }

  getmobileDetailsProgressStatus(): Observable<mobileProgressBarModel> {
    return this.mobiledetailsProgress.asObservable();
  }

  setmobileGauranteeProgressStatus(value: mobileProgressBarModel) {
    this.mobileguaranteeProgress.next(value);
  }

  getmobileGauranteeProgressStatus(): Observable<mobileProgressBarModel> {
    return this.mobileguaranteeProgress.asObservable();
  }

  setmobileSummaryProgressStatus(value: mobileProgressBarModel) {
    this.mobilesummaryProgress.next(value);
  }

  getmobileSummaryProgressStatus(): Observable<mobileProgressBarModel> {
    return this.mobilesummaryProgress.asObservable();
  }

  setmobileSignatureProgressStatus(value: mobileProgressBarModel) {
    this.mobilesignatureProgress.next(value);
  }

  getmobileSignatureProgressStatus(): Observable<mobileProgressBarModel> {
    return this.mobilesignatureProgress.asObservable();
  }
 
  //setmobileP5XProgressStatus(value: mobileProgressBarModel) {
  //  this.mobileP5XProgress.next(value);
  //}

  //getmobileP5XProgressStatus(): Observable<mobileProgressBarModel> {
  //  return this.mobilesignatureProgress.asObservable();
  //}

  //getmobileP5XProgressBarDetails() {
  //  throw new Error('Method not implemented.');
  //}
}
